export abstract class EnvService {
  apiHost = '';
  useContentV2 = false;
  useFileUploadWizard = false;
  applicationInsightsKey = '';
}
